import DropboxOSIcon from 'assets/DropboxOSMark.svg';
import airtableLogo from 'assets/logos/airtable.svg';
import confluenceLogo from 'assets/logos/confluence.svg';
import dropboxLogo from 'assets/logos/dropbox.svg';
import googleDriveLogo from 'assets/logos/google_drive.svg';
import jiraLogo from 'assets/logos/jira.svg';
import paperLogo from 'assets/logos/paper.svg';
import slackLogo from 'assets/logos/slack.svg';

/** Connected-app keys. Must stay in sync with backend CONNECTED_APP_KEYS. */
export type AutodraftAppKey =
  | 'jira'
  | 'confluence'
  | 'paper'
  | 'dropbox'
  | 'dropboxos'
  | 'slack'
  | 'google_drive'
  | 'airtable';

type AutodraftApp = {
  key: AutodraftAppKey;
  label: string;
  /** URL to the full-color brand SVG. */
  imgSrc: string;
};

// Every mark is a full-color brand SVG (dig-icons only ships monochrome
// `currentColor` variants, so we import real logos to keep true brand color).
// Each SVG is normalized to a 0 0 24 24 viewBox with the art fit to a centered
// ~16px region so every logo renders at a uniform optical size.
export const AUTODRAFT_APPS: AutodraftApp[] = [
  {key: 'dropboxos', label: 'CompanyOS', imgSrc: DropboxOSIcon},
  {key: 'dropbox', label: 'Dropbox', imgSrc: dropboxLogo},
  {key: 'paper', label: 'Paper', imgSrc: paperLogo},
  {key: 'jira', label: 'Jira', imgSrc: jiraLogo},
  {key: 'confluence', label: 'Confluence', imgSrc: confluenceLogo},
  {key: 'google_drive', label: 'Google Drive', imgSrc: googleDriveLogo},
  {key: 'slack', label: 'Slack', imgSrc: slackLogo},
  {key: 'airtable', label: 'Airtable', imgSrc: airtableLogo},
];

export const AutodraftAppIcon = ({app, size = 20}: {app: AutodraftApp; size?: number}) => (
  // All marks share a 0 0 24 24 viewBox, so a square box keeps them uniform.
  <img src={app.imgSrc} alt={app.label} width={size} height={size} style={{display: 'block'}} />
);
